function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createCtx } from "../../../utils/createCtx";
import React, { useRef } from "react";
var ref = _slicedToArray(createCtx(), 3), useNav = ref[0], NavProvider = ref[1], NavigationContext = ref[2];
var NavigationConsumer = NavigationContext.Consumer;
function NavigationProvider(param) {
    var actionItems = param.actionItems, appSwitcher = param.appSwitcher, children = param.children, CustomMenuItem = param.CustomMenuItem, disabledText = param.disabledText, Filters = param.Filters, globalNav = param.globalNav, helpMenu = param.helpMenu, id = param.id, isRtl = param.isRtl, Link = param.Link, localNav = param.localNav, logo = param.logo, onSearch = param.onSearch, page = param.page, title = param.title, recentItems = param.recentItems, search = param.search, setSearchTerm = param.setSearchTerm, user = param.user, userUtilities = param.userUtilities, viewProfileText = param.viewProfileText;
    var ref1;
    var LinkRef = useRef(Link);
    var CustomMenuItemRef = useRef(CustomMenuItem);
    var enabledApps = appSwitcher === null || appSwitcher === void 0 ? void 0 : (ref1 = appSwitcher.items) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
        return item.status === 'enabled';
    });
    var data = {
        actionItems: actionItems,
        appSwitcher: _objectSpread({}, appSwitcher, {
            items: enabledApps
        }),
        CustomMenuItem: CustomMenuItemRef.current,
        disabledText: disabledText,
        Filters: Filters,
        globalNav: globalNav,
        helpMenu: helpMenu,
        id: id,
        isRtl: isRtl,
        Link: LinkRef.current,
        localNav: localNav,
        logo: logo,
        onSearch: onSearch,
        page: page,
        title: title,
        recentItems: recentItems,
        search: search,
        setSearchTerm: setSearchTerm,
        user: user,
        userUtilities: userUtilities,
        viewProfileText: viewProfileText
    };
    return _jsx(NavProvider, {
        value: data,
        children: children
    });
}
var useNavigation = function() {
    return useNav();
};
export { NavigationContext, NavigationProvider, NavigationConsumer, useNavigation };
